import apiClient from '../apiClient';
import { PUT_ADDITIONAL_INFO_PACKAGE_URL } from '../apiUrl';

const putAdditionalInfoApi = (id, data) => {
  return apiClient.post(PUT_ADDITIONAL_INFO_PACKAGE_URL(id), data);
};

export default putAdditionalInfoApi;
